export default {
  computed : {
    isGlobalLoading(){
      return this.$store.state.globalLoading.isLoading;
    }
  }
  //, mounted(){
  //   setTimeout(() => {
  //     this.$store.dispatch('globalLoading/updateGlobalLoading', true, {root:true});
  //   }, 5000);
  // }
}